import { render, staticRenderFns } from "./add-edit-referrer-list-dialog.vue?vue&type=template&id=50cec18e"
import script from "./add-edit-referrer-list-dialog.vue?vue&type=script&lang=js"
export * from "./add-edit-referrer-list-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports